<template>
  <div class="container mt-4">
    <h3 class="text-center py-2">
      <b><i>Bloqueo de periodos</i></b>
    </h3>
    <b-card class="shadow">
      <div class="mb-3 text-muted" v-if="loadingPeriodos">
        <small>
          <b-icon-arrow-repeat animation="spin" class="mr-1"></b-icon-arrow-repeat>
          Cargando vigencias...
        </small>
      </div>

      <!-- Lista de vigencias -->
      <div v-if="Object.keys(periodosDisponibles).length > 0">
        <h5 class="mb-3">Vigencias Disponibles</h5>
        <p class="text-muted mb-3">
          <small>
            <b-icon-info-circle></b-icon-info-circle>
            Si una vigencia se deshabilita, no permitirá cargues o modificaciones en ese período específico
          </small>
        </p>
        
        <b-list-group>
                    <!-- Línea con error - NO USES index si no lo necesitas -->
                    <b-list-group-item v-for="periodo in sortedPeriodos" :key="periodo"
                        :class="{ 'disabled-period': !isPeriodoEnabled(periodo) }"
                        class="d-flex justify-content-between align-items-center">
           
            <div>
              <span class="font-weight-bold">{{ formatPeriodo(periodo) }}</span>
            </div>
            <b-form-checkbox 
              :checked="isPeriodoEnabled(periodo)"
              switch
              @change="togglePeriodo(periodo, $event)"
            />
          </b-list-group-item>
        </b-list-group>

        <!-- Botones de acción -->
        <div class="mt-4">
          <b-button 
            variant="primary" 
            @click="saveAllPeriodos"
            :disabled="!hasChanges"
          >
            <b-icon-save class="mr-2"></b-icon-save>
            Guardar Cambios
          </b-button>
          
        </div>
      </div>

      <!-- Mensaje cuando no hay períodos -->
      <div v-else class="text-center text-muted py-4">
        <b-icon-calendar-x font-scale="3" class="mb-3"></b-icon-calendar-x>
        <p>No hay vigencias disponibles</p>
      </div>
    </b-card>
  </div>
</template>

<script>
import Periodos from "../../services/Periodos"

export default {
  name: 'PanelAdminPeriodo',
  
  data() {
    return {
      periodosDisponibles: {},
      originalPeriodos: {},
      hasChanges: false,
      loadingPeriodos: false
    }
  },
  
  computed: {
    sortedPeriodos() {
      return Object.keys(this.periodosDisponibles).sort((a, b) => Number(b) - Number(a))
    }
  },
  
    methods: {
        normalizePeriodo(periodo) {
            return String(periodo || '').replace(/\D/g, '').trim()
        },

        extractVigenciaValue(item) {
            if (item === null || item === undefined) return ''
            if (typeof item === 'string' || typeof item === 'number') return String(item)
            if (item.vigencia !== undefined && item.vigencia !== null) return String(item.vigencia)
            if (item.dataValues && item.dataValues.vigencia !== undefined && item.dataValues.vigencia !== null) {
                return String(item.dataValues.vigencia)
            }
            return ''
        },

        formatPeriodo(periodo) {
            if (!periodo) return ''
            const normalized = this.normalizePeriodo(periodo)
            if (normalized.length === 6) {
                return `${normalized.substring(0, 4)}-${normalized.substring(4, 6)}`
            }
            return normalized
        },

        isPeriodoEnabled(periodo) {
            return this.$store.getters.isPeriodoEnabled(periodo)
        },

        async loadPeriodosFromAPI() {
            this.loadingPeriodos = true
            try {
                const response = await Periodos.getPeriodosControl()
                const periodosAPI = Array.isArray(response.data.periodos) ? response.data.periodos : []
                const periodosMap = {}

                periodosAPI.forEach((item) => {
                    const vigencia = this.normalizePeriodo(item.vigencia)
                    if (!vigencia) return
                    periodosMap[vigencia] = item.enabled !== false
                })

                if (Object.keys(periodosMap).length > 0) {
                    this.$store.commit('setPeriodos', periodosMap)
                    this.periodosDisponibles = { ...periodosMap }
                    this.originalPeriodos = { ...periodosMap }
                    this.hasChanges = false
                } else {
                    this.$store.commit('setPeriodos', {})
                    this.periodosDisponibles = {}
                    this.originalPeriodos = {}
                    this.hasChanges = false
                    this.$bvToast.toast('No se encontraron vigencias en la base de datos', {
                        title: 'Información',
                        variant: 'info',
                        solid: true
                    })
                }
            } catch (error) {
                console.error('Error cargando períodos:', error)
                this.$bvToast.toast('Error al cargar vigencias desde la base de datos', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                })
            } finally {
                this.loadingPeriodos = false
            }
        },
    
    togglePeriodo(periodo, enabled) {
      // Guardar cambio localmente
      this.periodosDisponibles[periodo] = enabled
      this.hasChanges = true
    },
    
    async saveAllPeriodos() {
      try {
        const periodos = Object.keys(this.periodosDisponibles).map((periodo) => ({
          vigencia: this.normalizePeriodo(periodo),
          enabled: this.periodosDisponibles[periodo]
        }))

        await Periodos.savePeriodosControl(periodos, this.$store.state.userId)
        this.$store.commit('setPeriodos', { ...this.periodosDisponibles })
        this.originalPeriodos = { ...this.periodosDisponibles }
        this.hasChanges = false

        this.$bvToast.toast('Configuración de vigencias guardada exitosamente', {
          title: 'Éxito',
          variant: 'success',
          solid: true
        })
      } catch (error) {
        console.error('Error guardando periodos:', error)
        this.$bvToast.toast('Error al guardar configuración de vigencias', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
    },
    
    resetChanges() {
      this.periodosDisponibles = { ...this.originalPeriodos }
      this.hasChanges = false
    }
  },
  
  watch: {
    periodosDisponibles: {
      deep: true,
      handler(newVal) {
        const changes = Object.keys(newVal).some(key => 
          newVal[key] !== this.originalPeriodos[key]
        )
        this.hasChanges = changes
      }
    }
  },
  
  mounted() {
    this.loadPeriodosFromAPI()
  }
}
</script>

<style scoped>
.list-group-item {
  transition: all 0.3s ease;
}

.list-group-item:hover {
  background-color: #f8f9fa;
}

.disabled-period {
  background-color: #f8f9fa;
  opacity: 0.7;
}

.disabled-period:hover {
  background-color: #e9ecef;
}
</style>
